import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Button, Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import {MESSAGE_PROPTYPE} from '@salesforce/retail-react-app/app/utils/locale.js'

const FormActionButtons = ({
    saveButtonProps = {},
    cancelButtonProps = {},
    saveButtonLabel,
    cancelButtonLabel,
    onCancel = () => {},
    isCancle = false,
    directionType = 'row-reverse'
}) => {
    return (
        <Stack direction={{base: 'column', lg: directionType}} justifyContent={'center'}>
            <Button type="submit" className="button-primary" {...saveButtonProps} flex={1}>
                {saveButtonLabel ? (
                    <FormattedMessage {...saveButtonLabel} />
                ) : (
                    <FormattedMessage defaultMessage="Save" id="form_action_buttons.button.save" />
                )}
            </Button>
            {isCancle && (
                <Button
                    variant="outline"
                    className="button-outline"
                    onClick={onCancel}
                    {...cancelButtonProps}
                    flex={1}
                >
                    {cancelButtonLabel ? (
                        <FormattedMessage {...cancelButtonLabel} />
                    ) : (
                        <FormattedMessage
                            id="form_action_buttons.button.cancel"
                            defaultMessage="Cancel"
                        />
                    )}
                </Button>
            )}
        </Stack>
    )
}

FormActionButtons.propTypes = {
    saveButtonProps: PropTypes.object,
    cancelButtonProps: PropTypes.object,
    saveButtonLabel: MESSAGE_PROPTYPE,
    cancelButtonLabel: MESSAGE_PROPTYPE,
    onCancel: PropTypes.func,
    isCancle: PropTypes.bool,
    directionType: PropTypes.string
}

export default FormActionButtons
